import { shipStatusHistory } from '@/config'
import commonUtil from '@/util/commonUtil'

export default {
  getShipArrivalStatusList() {
    return commonUtil.getStatusHistoryIdNameList(
      shipStatusHistory.ARRIVAL_STATUS,
      shipStatusHistory.STATUS_HISTORY_LABEL
    )
  },

  getShipArrivalStatusName(status) {
    const ret = this.getShipArrivalStatusList().find(
      (ele) => ele.value === status
    )
    return ret ? ret.label : '-'
  }
}
